import { c as t } from "./chunk-DDHXTT42.mjs";
var o,
    e = t(function () {
  o = ["Canada"];
});
var r,
    i = t(function () {
  r = ["A#? #?#", "B#? #?#", "C#? #?#", "E#? #?#", "G#? #?#", "H#? #?#", "J#? #?#", "K#? #?#", "L#? #?#", "M#? #?#", "N#? #?#", "P#? #?#", "R#? #?#", "S#? #?#", "T#? #?#", "V#? #?#", "X#? #?#", "Y#? #?#"];
});
var a,
    n = t(function () {
  a = ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Northwest Territories", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"];
});
var m,
    f = t(function () {
  m = ["AB", "BC", "MB", "NB", "NL", "NS", "NU", "NT", "ON", "PE", "QC", "SK", "YT"];
});
var C,
    p,
    d = t(function () {
  e();
  i();
  n();
  f();
  C = {
    default_country: o,
    postcode: r,
    state: a,
    state_abbr: m
  }, p = C;
});
var s,
    l = t(function () {
  s = ["ca", "com", "biz", "info", "name", "net", "org"];
});
var u,
    x = t(function () {
  u = ["gmail.com", "yahoo.ca", "hotmail.com"];
});
var P,
    c,
    N = t(function () {
  l();
  x();
  P = {
    domain_suffix: s,
    free_email: u
  }, c = P;
});
var b,
    h = t(function () {
  b = ["!##-!##-####", "(!##)!##-####", "!##.!##.####", "1-!##-###-####", "!##-!##-#### x###", "(!##)!##-#### x###", "1-!##-!##-#### x###", "!##.!##.#### x###", "!##-!##-#### x####", "(!##)!##-#### x####", "1-!##-!##-#### x####", "!##.!##.#### x####", "!##-!##-#### x#####", "(!##)!##-#### x#####", "1-!##-!##-#### x#####", "!##.!##.#### x#####"];
});

var _,
    D,
    B = t(function () {
  h();
  _ = {
    formats: b
  }, D = _;
});

var w,
    V,
    y = t(function () {
  d();
  N();
  B();
  w = {
    title: "English (Canada)",
    address: p,
    internet: c,
    phone_number: D
  }, V = w;
});
export { V as a, y as b };